<script>
import AdvancedSearch from '@/components/search/advanced/AdvancedSearch.vue'
import LibraryMetadataMixin from '@/components/search/advanced/LibraryMetadataMixin.vue'

export default {
  name: 'MagazineAdvancedSearch',
  extends: AdvancedSearch,
  mixins: [LibraryMetadataMixin],
  computed: {
    limitFieldConfig() {
      return [
        this.standardField('public_tag'),
        this.standardField('format'),
        this.standardField('place'),
        this.standardField('title'),
        this.standardField('access'),
        this.standardField('rights'),
        this.standardField('category'),
        this.standardField('year'),
        this.standardField('language'),
        this.standardField('austlang'),
        this.standardField('illustration_type'),
        this.standardField('word_count'),
      ]
    },
  },
}
</script>
